import React, { Fragment, useEffect, useState } from 'react'
import classnames from 'classnames'
import { Button, Flex, InputText, Text, Tooltip, useToast } from '@driftt/dds'
import { faFilter } from '@driftt/dds.icons/dist/light/faFilter'
import { Span } from '@driftt/tide-core'
import { SegmentBuilderSidebar } from '@driftt/cyberno'
import { PropertyCreatorModal } from '@driftt/property-creator'

import { pluralize } from 'humanize-plus'

import { isRuleSetValid } from 'utils/segment'
import { EMPTY_SEGMENT_MODEL } from 'constants/segment'

const AccountsTableToolBar = (props) => {
  const triggerToast = useToast()
  const [isOpen, setIsOpen] = useState(false)
  const [showPropertyCreator, setShowPropertyCreator] = useState(false)

  const {
    searchChange,
    searchText,
    accounts = [],
    createSegment,
    toggleConfirmDeleteModal,
    selectedRows = [],
    deleteLoading,
    segment,
    onFilterUpdate,
    canDeleteAll
  } = props

  const toggle = () => {
    setIsOpen(prevState => (!prevState))
  }

  const togglePropertyCreator = () => {
    setShowPropertyCreator(prevState => (!prevState))
  }

  useEffect(() => {
    if (createSegment === true) {
      toggle();
    }
  }, [createSegment]);

  const canFilter = !searchText

  const segmentExistsAndIsValid = segment && isRuleSetValid(segment)
  const canSearch = !segmentExistsAndIsValid
  const isSegmentView = !!segment
  const searchTooltip = !canSearch ? 'Search is disabled when filters are applied.' : null
  const filterTooltip = !canFilter ? 'Filters are disabled when search terms are applied.' : null

  return (
    <Fragment>
      <Flex direction="row"
            gap={2}
            alignItems="center"
            justifyContent="space-between"
            css={{ paddingY: '$2' }}
            fullWidth
      >
        <Flex alignItems="center">
          <Tooltip content={searchTooltip} side="top">
            <InputText
              onChange={searchChange}
              disabled={!canSearch}
              label="Search"
              hideLabel
              placeholder="Search"
              value={searchText}
              size="medium"
            />
          </Tooltip>
          <Tooltip content={filterTooltip} side="top">
            <Button
              variant="secondary"
              disabled={!canFilter}
              onClick={toggle}
            >
              <Button.Icon icon={faFilter} />
              Filter
            </Button>
          </Tooltip>
          <Text>
            {accounts.totalResults} accounts
          </Text>

          {!!selectedRows.length &&
            <Fragment>
              <Text className="accounts-total-selected">
                {`${selectedRows.length} selected`}
              </Text>
              <Text className={classnames({ 'accounts-delete-loading': deleteLoading })}>
                {!deleteLoading && <Span className="accounts-toolbar-bulk-delete" onClick={toggleConfirmDeleteModal()}>{`Delete ${pluralize(selectedRows.length, 'account')}`}</Span>}

                {canDeleteAll && !deleteLoading && !isSegmentView &&
                  <Fragment> or <Span className="accounts-toolbar-bulk-delete" onClick={toggleConfirmDeleteModal(true)}>Delete All Accounts</Span> </Fragment>
                }
              </Text>
            </Fragment>
          }
        </Flex>
        <Button
          onClick={togglePropertyCreator}
          variant="secondary"
        >
          Create property
        </Button>
      </Flex>

      <SegmentBuilderSidebar
        isOpen={isOpen}
        onSave={toggle}
        close={toggle}
        propertyTypes={['ACCOUNT']}
        outputType="ACCOUNT"
        onUpdate={onFilterUpdate}
        segment={(!!segment && isRuleSetValid(segment)) ? segment : EMPTY_SEGMENT_MODEL}
      />
      <PropertyCreatorModal
        isOpen={showPropertyCreator}
        onClose={togglePropertyCreator}
        onSaveSuccess={() => {
          togglePropertyCreator()
          triggerToast({
            variant: 'success',
            message: 'Account property successfully created'
          })
        }}
        createType="ACCOUNT"
        hideOverlay={true}
      />
    </Fragment>
  )
}

export default AccountsTableToolBar
